module.exports = __webpack_public_path__ + "img/gift-friend-top.65bf768b.png";